import router from "./router";
import "core-js/stable";
import "./plugins";
import "./config";
import "vuetify-dialog/dist/vuetify-dialog.css";

import App from "./App.vue";
import TextHighlight from "vue-text-highlight";
import Vue from "vue";
import VuetifyDialog from "vuetify-dialog";
import cssVars from "css-vars-ponyfill";
import i18n from "./plugins/i18n";
import store from "./store";
import vuetify from "./plugins/vuetify";
import ebsn from "~/functions";
import SmartBanner from "smart-app-banner";

import { showToaster, showConfirm, showNotification } from "~/notifications";

import "smart-app-banner/dist/smart-app-banner.css";
import "./scss/app.scss";
if (navigator.platform == "Win32") import("./scss/scrollbar.scss");

Vue.config.productionTip = false;

cssVars({});

global.EventBus = new Vue({
  i18n
});

Vue.component("text-highlight", TextHighlight);

Vue.use(VuetifyDialog, {
  context: {
    vuetify,
    store,
    router,
    i18n
  },
  confirm: {
    actions: {
      false: "No",
      true: {
        text: "Si",
        color: "secondary--text",
        class: "secondary--text"
      }
    },
    icon: true
  }
});
Vue.use(ebsn);

Vue.mixin({
  data() {
    return {
      isCordova: typeof process.env.VUE_APP_CORDOVA_PLATFORM != "undefined"
    };
  },
  computed: {
    $platform_is_cordova: () => typeof cordova !== "undefined",
    isFluid() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    isPrerender() {
      var isPrerender =
        navigator.userAgent.toLowerCase().indexOf("prerender") !== -1;
      return isPrerender;
    }
  }
});

Vue.prototype.$dialog.on("shown", ({ dialog }) => {
  global.config.dialogs.push(dialog);
});

Vue.prototype.$dialog.on("destroyed", ({ dialog }) => {
  global.config.dialogs = global.config.dialogs.filter(
    _dialog => _dialog.id !== dialog.id
  );
});

Vue.prototype.$dialog.clearDialogs = () => {
  global.config.dialogs.forEach(_dialog => _dialog.remove());
  global.config.dialogs = [];
};

const vm = new Vue({
  router,
  store,
  vuetify,
  i18n,
  created() {
    if (!process.env.VUE_APP_CORDOVA_PLATFORM) {
      new SmartBanner({
        daysHidden: 7, // days to hide banner after close button is clicked (defaults to 15)
        daysReminder: 14, // days to hide banner after "VIEW" button is clicked (defaults to 90)
        appStoreLanguage: "it", // language code for the App Store (defaults to user's browser language)
        title: process.env.VUE_APP_STORE_TITLE,
        author: "",
        button: "Installa",
        store: {
          ios: "Scarica l'app",
          android: "Scarica l'app"
        },
        price: {
          ios: "",
          android: ""
        },
        icon: "/img_layout/app_icon.png"
        // , force: 'ios' // Uncomment for platform emulation
      });
    }
  },
  render: h => h(App)
}).$mount("#app");

global.vm = vm;

const toastedOption = {
  position: "bottom-center",
  duration: 3000,
  iconPack: "mdi",
  theme: "bubble",
  keepOnHover: true,
  action: {
    icon: "$clear",
    onClick: (e, toastObject) => {
      toastObject.goAway(0);
    }
  }
};
global.EventBus.$on("error", payload => {
  showToaster("error", payload, toastedOption);
});
global.EventBus.$on("warning", payload => {
  showToaster("warning", payload, toastedOption);
});
global.EventBus.$on("success", payload => {
  showToaster("success", payload, toastedOption);
});

global.EventBus.$on("confirm", showConfirm);

global.EventBus.$on("notification", showNotification);

global.EventBus.$on("toggleModal", isModalOpened => {
  if (isModalOpened) {
    if (document.body.style.position != "fixed") {
      let scrollY = "-" + parseInt(window.scrollY) + "px";
      document.body.classList.add("modal-open");
      document.body.style.position = "fixed";
      document.body.style.top = scrollY;
    }
  } else {
    document.body.style.position = "";
    document.body.classList.remove("modal-open");
    let bodyTop = document.body.style.top.replace("px", "");
    let numberY = Math.abs(parseInt(bodyTop));
    document.body.style.top = "";
    window.scrollTo(0, numberY);
  }
});

window.handleOpenURL = function(url) {
  setTimeout(() => {
    console.log("::::: window.handleOpenURL ::::: ", url);
    store.dispatch("handleOpenUrl", {
      url: url
    });
  });
};
